import base from './base.repository';
export default {
    ...base,
    loadStartQuestions(payload){
        this.get(`clients/${payload.clientId}/start-questions`);
        return this;
    },
    loadAnswerTypes(){
        this.get('vigilance/answer-types');
        return this;
    },
    loadVigilanceRoles(){
        this.get('vigilance/vigilance-roles');
        return this;
    },
    startShift(structureId, userId, data){
        this.post(`vigilance/structure/${structureId}/user/${userId}/start-shift`, data);
        return this;
    },
    loadMasterData(payload){
        this.get(`vigilance/client/${payload.clientId}/shift-master-data?structure=${payload.structureId}`);
        return this;
    },
    validateOpenShift(structureId, userId){
        this.get('vigilance/validate-open-shift?structure='+structureId+'&user='+userId);
        return this;
    },
    getShiftsToolStatuses(filters, page){
        const params = {...filters, page: page};
        this.get(`shifts/tools-statuses${this.querify(params)}`);
        return this;
    },
    
}